// reduced-motion.js
/**
 * Tiny utilities for respecting prefers-reduced-motion across GSAP modules.
 * - setupMotion(gsap, { reduced, full }): register reduced + full branches with gsap.matchMedia
 * - revealElements(gsap, root, selector): ensure elements are visible when skipping animations
 * - isReducedMotion(): boolean
 * - reducedDuration(ms): 0 if reduced, else the given duration
 */

export const isReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const setupMotion = (gsap, {reduced, full}) => {
  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: reduce)', () => {
    if (typeof reduced === 'function') reduced();
  });
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    if (typeof full === 'function') full();
  });
  return mm;
};

export const revealElements = (gsap, root, selector = '[data-element]') => {
  let targets = [];
  if (!root) {
    targets = gsap.utils.toArray(selector);
  } else if (typeof root === 'string') {
    targets = gsap.utils.toArray(root);
  } else if (root.nodeType === 1) {
    targets = root.querySelectorAll(selector);
  } else if (Array.isArray(root) || (root.length && root[0] && root[0].nodeType)) {
    targets = root;
  }
  if (targets && targets.length) {
    gsap.set(targets, {autoAlpha: 1});
  }
};

export const reducedDuration = (d) => (isReducedMotion() ? 0 : d);
